export enum DeviceInsightsNavigationType {
  Missions = "missions",
  Errors = "errors",
  Charts = "charts",
}
